import { toString } from 'lodash';
// 按钮权限对象
export const permissionCode = {
    adjustApprover: '/distribute/car-check/adjustApproverBtn' // 调整审批人
};

export default {
    configuration: false,
    searchList: {
        // fieldTrim 为 true 时 对查询条件字段值进行 trim 而不是 替换空白字符
        fieldTrim: true,
        searchTxt: [
            {
                name: '分公司',
                value: 'companyName',
                unfold: true,
                type: 'advance',
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', 'value': '分公司名称' },
                    { prop: 'escoCompanyNo', 'value': '分公司编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNo', 'value': '分公司编码' },
                    { prop: 'escoCompanyNameCn', 'value': '分公司名称' }
                ],
                advanceUrl: '/searchBrand',
                cbParams: ['escoCompanyNameCn#companyName', 'escoCompanyNo#companyCode'],
                span: 3
            },
            {
                name: '服务平台',
                value: 'siteName',
                type: 'advance',
                unfold: true,
                multiple: true,
                border: true,
                dialogWidth: '800px',
                maxSelect: 15,
                multipleTableColumn: {
                    prop: 'escoCompanyNameCn', 'value': '服务平台名称'
                },
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' }
                ],
                advanceUrl: '/searchPlatform',
                cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                span: 3
            },
            // {
            //     name: '请输入承运商',
            //     advanceLabel: '承运商',
            //     value: 'supplierName',
            //     type: 'advance',
            //     unfold: true,
            //     advanceConfig: [
            //         { prop: 'supplierNameCn', value: '承运商名称' },
            //         { prop: 'supplierCode', value: '承运商编码' }
            //     ],
            //     tableConfig: [
            //         { prop: 'supplierNameCn', value: '承运商名称' },
            //         { prop: 'supplierCode', value: '承运商编码' }
            //     ],
            //     advanceNotSearch: true,
            //     queryConditionRequired: true,
            //     method: 'post',
            //     advanceUrl: 'srm/supplier/search',
            //     prefix: '/api-tms/',
            //     cbParams: ['supplierNameCn#supplierName', 'supplierCode#carrierCode'],
            //     span: 3
            // },
            {
                name: '状态',
                value: 'inspectionStatusList',
                type: 'select',
                multiple: true,
                optionNum: 'CAR_CHECK_STATUS',
                unfold: true,
                span: 3
            },
            {
                name: '发车单号(支持批量查询，最多100单)',
                value: 'dispatchNo',
                type: 'input',
                unfold: true,
                span: 4
            },
            {
                name: '创建时间',
                value: 'createTime',
                type: 'time',
                unfold: true,
                timeNum: 3,
                span: 6
            },
            {
                name: '客户',
                value: 'customerName',
                prop: 'customerName',
                type: 'advance',
                readOnly: false,
                multiple: true,
                maxSelect: 5,
                border: true,
                dialogWidth: '800px',
                multipleTableColumn: {
                    prop: 'ebcuNameCn', 'value': '客户名称'
                },
                advanceConfig: [
                    { prop: 'ebcuNameCn', value: '客户名称' },
                    { prop: 'pmCode', value: '客户编码' }
                ],
                tableConfig: [
                    { prop: 'pmCode', value: '客户编码' },
                    { prop: 'ebcuNameCn', value: '客户名称' }
                ],
                cbParams: ['pmCode#customerCode', 'ebcuNameCn#customerName'],
                advanceUrl: '/ebCustomer/searchByEbCustomer',
                unfold: true,
                span: 3
            },
            {
                name: '客户属性',
                value: 'customerAttributes',
                type: 'select',
                multiple: true,
                optionNum: 'LMDM_CUSTOMER_CHANNEL',
                options: [],
                unfold: true,
                span: 3
            },
            {
                name: '专业公司',
                value: 'professionalCompany',
                type: 'select',
                filterable: true,
                optionNum: 'SYS_PROFESSIONAL_COMPANY',
                options: [],
                unfold: true,
                span: 3
            },
            {
                name: '发车单状态',
                value: 'dispatchStatusList',
                type: 'select',
                filterable: true,
                multiple: true,
                optionNum: 'DISPATCH_STATUS',
                options: [],
                unfold: true,
                span: 3
            },
            {
                name: '发运类型',
                value: 'shippingType',
                type: 'select',
                filterable: true,
                optionNum: 'TMS_SHIPPING_TYPE',
                options: [],
                unfold: true,
                span: 2
            },
            {
                name: '审批状态',
                value: 'approveStatus',
                type: 'select',
                filterable: true,
                optionNum: 'CAR_CHECK_MANAGE_APPROVA_STATUS',
                options: [],
                unfold: true,
                span: 2
            },
            {
                name: 'AI分析结果',
                value: 'aiResult',
                type: 'select',
                filterable: true,
                multiple: false,
                optionNum: 'TMS_AI_RESULT',
                options: [],
                unfold: true,
                span: 2
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        expandTable: true,
        clickModify: true,
        selectBtn: true,
        leftWidth: 60,
        height: '400px',
        leftOperation: true,
        columns: [
            {
                label: '发车单号',
                prop: 'dispatchNo',
                width: 160,
                sort: true
            },
            {
                label: '车牌号',
                prop: 'vehicleCard',
                width: 160,
                sort: true
            },
            {
                label: '司机姓名',
                prop: 'driver',
                width: 160,
                sort: true
            },
            {
                label: '分公司',
                prop: 'companyName',
                width: 160,
                sort: true
            },
            {
                label: '服务平台',
                prop: 'siteName',
                width: 160,
                sort: true
            },
            {
                label: '客户名称',
                prop: 'customerNames',
                width: 160,
                sort: true
            },
            {
                label: '客户属性',
                prop: 'customerAttribute',
                width: 120,
                sort: true
            },
            {
                label: '承运商名称',
                prop: 'carrierName',
                width: 220,
                sort: true
            },
            {
                label: '发运类型',
                prop: 'shippingTypeStr',
                type: 'select',
                optionNum: 'TMS_SHIPPING_TYPE',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: 'AI分析结果',
                prop: 'aiResult',
                type: 'select',
                optionNum: 'TMS_AI_RESULT',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '采购渠道',
                prop: 'procurementChannel',
                type: 'select',
                optionNum: 'OTP_TMS_PROCUREMENT_CHANNEL',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '专业公司',
                prop: 'professionalCompanys',
                width: 140,
                sort: true
            },
            {
                label: '提货仓库',
                prop: 'whNames',
                width: 160,
                sort: true
            },
            {
                label: '任务状态',
                prop: 'statusName',
                width: 120,
                sort: true
            },
            {
                label: '审批状态',
                prop: 'approveStatus',
                type: 'select',
                optionNum: 'CAR_CHECK_MANAGE_APPROVA_STATUS',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '发车单状态',
                prop: 'dispatchStatus',
                type: 'select',
                optionNum: 'DISPATCH_STATUS',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '行业大类',
                prop: 'industryCategory',
                type: 'select',
                optionNum: 'SYS_SUPPLIER_INDUSTRY',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '线路',
                prop: 'lineName',
                width: 160,
                sort: true
            },
            {
                label: '车型',
                prop: 'equipmentName',
                width: 120,
                sort: true
            },
            {
                label: '可审批人',
                prop: 'approverCodeList',
                width: 120,
                sort: true
            },
            {
                label: '创建时间',
                prop: 'createTime',
                width: 160,
                sort: true
            }
        ],
        action: [
            // {
            //     type: 'text',
            //     label: '调整审批人',
            //     size: 'small',
            //     event: 'adjust-approver',
            //     ifHas: permissionCode.adjustApprover,
            //     show(row) {
            //         // 待审批状态才显示
            //         return toString(row.approveStatus) === '0';
            //     }
            // }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    },
    searchTotalTitle: [
        {
            name: '司机',
            type: 'advance',
            value: 'driver',
            multiple: false,
            border: true,
            dialogWidth: '800px',
            maxSelect: 5,
            multipleTableColumn: {
                prop: 'name', 'value': '司机名称'
            },
            advanceConfig: [
                { 'prop': 'name', 'value': '司机名称' },
                { 'prop': 'encuMobile', 'value': '司机电话' }
            ],
            tableConfig: [
                { 'prop': 'name', 'value': '司机名称' },
                { 'prop': 'encuMobile', 'value': '司机电话' }
            ],
            advanceUrl: 'suDriver/searchByConditions',
            cbParams: [
                'name#driver', 'encuMobile#driverContactWay'
            ],
            span: 3
        },
        {
            name: '车牌号',
            advanceLabel: '车牌号',
            value: 'vehicleCard',
            multiple: false,
            border: true,
            dialogWidth: '800px',
            maxSelect: 5,
            multipleTableColumn: {
                prop: 'licensePlateNumber', 'value': '车牌'
            },
            advanceConfig: [
                { prop: 'licensePlateNumber', value: '车牌' },
                { prop: 'cargoVolumeStr', value: '载货体积' },
                { prop: 'cdegNameCn', value: '车型' }
            ],
            tableConfig: [
                { prop: 'licensePlateNumber', value: '车牌' },
                { prop: 'cargoVolume', value: '载货体积' },
                { prop: 'cdegNameCn', value: '车型' }
            ],
            advanceUrl: 'suCar/searchByConditions',
            type: 'advance',
            cbParams: ['licensePlateNumber#vehicleCard'],
            advanceCascade: 'carrierCode#suppliersCode',
            span: 3
        },
        {
            name: '审批人',
            type: 'advance',
            value: 'mipCount',
            advanceConfig: [
                { prop: 'queryParam', value: 'mip账号或名字' }
            ],
            tableConfig: [
                { prop: 'userCode', value: 'mip账号' },
                { prop: 'userName', value: '姓名' }
            ],
            prefix: '/api-auth/',
            advanceUrl: 'tenantUserInfos',
            cbParams: ['userName#mipName', 'userCode#mipCount']
        },
        {
            name: '行业大类',
            value: 'industryCategory',
            type: 'select',
            filterable: true,
            optionNum: 'SYS_SUPPLIER_INDUSTRY',
            options: [],
            span: 2
        },
        {
            name: '采购渠道',
            value: 'procurementChannel',
            type: 'select',
            filterable: true,
            optionNum: 'OTP_TMS_PROCUREMENT_CHANNEL',
            options: [],
            span: 2
        }
    ],
    pickerConfig: {
        shortcuts: [
            { type: 'd', num: 2, text: '最近三天', translate: 'component.E202007300011' },
            { type: 'd', num: 6, text: '最近一周', translate: 'component.E202007300011' },
            { type: 'M', num: 1, text: '最近一个月', translate: 'component.E202007300013' }
        ]
    }
};
